if (!customElements.get('cart-upsell-form')) {
  customElements.define(
    'cart-upsell-form',
    class CartUpsellForm extends HTMLElement {

      constructor() {
        super();

        this.submitButton = null;
        this.buttonText = null;
        this.loading = null;
        this.errorElement = null;
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.submitButton = this.querySelector(
          '[data-cart-upsell-submit]'
        );

        this.buttonText = this.querySelector(
          '.cart-upsell-card__button-text'
        );

        this.loading = this.querySelector(
          '.cart-upsell-card__loading'
        );

        this.errorElement = this.querySelector(
          '[data-cart-upsell-error]'
        );

        if (!this.submitButton) return;

        this.submitButton.addEventListener(
          'click',
          this.handleSubmit.bind(this)
        );
      }

      async handleSubmit(event) {
        event.preventDefault();

        if (
          this.submitButton.disabled ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        const variantId = parseInt(
          this.dataset.variantId,
          10
        );

        if (!variantId) {
          this.showError(
            'Product variant could not be found.'
          );
          return;
        }

        this.clearError();
        this.setLoading(true);

        try {

          const response = await fetch(
            routes.cart_add_url + '.js',
            {
              method: 'POST',

              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },

              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1
                  }
                ]
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              'Unable to add this product to the cart.'
            );
          }

          /*
           * IMPORTANT:
           * Remove this upsell immediately.
           */
          this.remove();

          /*
           * Tell the existing theme that an AJAX
           * product was added.
           */
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                product: data,
                source: 'cart-upsell'
              }
            })
          );

          /*
           * Wait for the theme's cart update/re-render,
           * then synchronize the upsells again.
           */
          setTimeout(() => {
            CartUpsellManager.sync();
          }, 500);

        } catch (error) {

          console.error(
            'Cart upsell AJAX error:',
            error
          );

          this.showError(
            error.message ||
            'Unable to add this product to the cart.'
          );

          this.setLoading(false);
        }
      }

      setLoading(isLoading) {

        if (!this.submitButton) return;

        if (isLoading) {

          this.submitButton.disabled = true;

          this.submitButton.setAttribute(
            'aria-disabled',
            'true'
          );

          this.submitButton.classList.add(
            'loading'
          );

          if (this.buttonText) {
            this.buttonText.hidden = true;
          }

          if (this.loading) {
            this.loading.hidden = false;
          }

        } else {

          this.submitButton.disabled = false;

          this.submitButton.removeAttribute(
            'aria-disabled'
          );

          this.submitButton.classList.remove(
            'loading'
          );

          if (this.buttonText) {
            this.buttonText.hidden = false;
          }

          if (this.loading) {
            this.loading.hidden = true;
          }
        }
      }

      showError(message) {

        if (!this.errorElement) return;

        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }

      clearError() {

        if (!this.errorElement) return;

        this.errorElement.textContent = '';
        this.errorElement.hidden = true;
      }
    }
  );
}


/*
|--------------------------------------------------------------------------
| CART UPSELL MANAGER
|--------------------------------------------------------------------------
*/

if (!window.CartUpsellManager) {

  window.CartUpsellManager = {

    async getCart() {

      try {

        const response = await fetch(
          routes.cart_url + '.js',
          {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            cache: 'no-store'
          }
        );

        if (!response.ok) {
          throw new Error(
            'Could not get cart.'
          );
        }

        return await response.json();

      } catch (error) {

        console.error(
          'Cart upsell cart sync error:',
          error
        );

        return null;
      }
    },


    async sync() {

      const cart = await this.getCart();

      if (!cart) return;

      const cartProductIds = new Set();

      const cartVariantIds = new Set();

      cart.items.forEach(item => {

        if (item.product_id) {
          cartProductIds.add(
            String(item.product_id)
          );
        }

        if (item.variant_id) {
          cartVariantIds.add(
            String(item.variant_id)
          );
        }

        if (item.id) {
          cartVariantIds.add(
            String(item.id)
          );
        }

      });


      /*
       * Remove upsells that are already in cart.
       */
      document
        .querySelectorAll(
          'cart-upsell-form'
        )
        .forEach(card => {

          const productId =
            String(
              card.dataset.productId || ''
            );

          const variantId =
            String(
              card.dataset.variantId || ''
            );

          if (
            cartProductIds.has(productId) ||
            cartVariantIds.has(variantId)
          ) {

            card.remove();

          }

        });


      /*
       * If the theme has re-rendered the cart,
       * Liquid will decide which upsells belong here.
       *
       * If the upsell container disappeared because
       * everything is in cart, do nothing.
       */
    }
  };
}


/*
|--------------------------------------------------------------------------
| SYNC AFTER NORMAL AJAX CART ADD
|--------------------------------------------------------------------------
*/

document.addEventListener(
  'ajaxProduct:added',
  function(event) {

    /*
     * Give the theme time to update the drawer.
     */
    setTimeout(() => {

      CartUpsellManager.sync();

    }, 500);

  }
);


/*
|--------------------------------------------------------------------------
| SYNC AFTER CART CHANGES
|--------------------------------------------------------------------------
*/

document.addEventListener(
  'cart:updated',
  function() {

    setTimeout(() => {

      CartUpsellManager.sync();

    }, 300);

  }
);


/*
|--------------------------------------------------------------------------
| INITIAL SYNC
|--------------------------------------------------------------------------
*/

document.addEventListener(
  'DOMContentLoaded',
  function() {

    setTimeout(() => {

      CartUpsellManager.sync();

    }, 300);

  }
);